<template>
  <a-modal class="attachable-category-attachable-upload-modal"
           title="Documenten uploaden" :closable="false"
           :visible="visible" width="60%">
    <DocumentUploadComponent
            ref="documentUploadComponent"
            :key="attachableCategory.id"
            :customer-id="customerId"
            :attachable-category-id="attachableCategory.id"
            :has-attachable-type="hasAttachableType"
            :has-attachable-id="hasAttachableId"
            v-on:created-document="onCreatedDocument"
            v-on:updated-document="onUpdatedDocument"/>
    <template slot="footer">
      <a-button key="back" @click="closeModal" type="default">
        Sluiten
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import DocumentUploadComponent from "~/modules/document/components/DocumentUploadComponent"

export default {
  name: "AttachableCategoryAttachableUploadModalComponent",
  components: {
    DocumentUploadComponent
  },
  props: {
    attachableCategory: {
      type: Object,
      required: true
    },
    customerId: {
      type: [Number, String],
      required: false,
    },
    hasAttachableType: {
      type: [String, Number],
      default: null,
      required: false
    },
    hasAttachableId: {
      type: [String, Number],
      default: null,
      required: false
    },
    visible: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    closeModal() {
      this.$refs.documentUploadComponent.clearFiles();
      this.$emit('close');
    },
    onCreatedDocument(document) {
      this.$emit('created-document', document);
    },
    onUpdatedDocument(document) {
      this.$emit('updated-document', document);
    }
  }
}
</script>
<style scoped>

</style>